import React from 'react';
import { Route, useParams } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { MANAGER } from 'authorization/role';
import { DeviceType } from 'utils/constant';
import UpdateTrailer from './UpdateTrailer';
import CreateTrailer from './CreateTrailer';

const TrailerPage = ({ role }) => {
    const { id } = useParams();
    const type = DeviceType.TRAILER;

    const filterDataForServer = item => {
        item.category = type;
        if(!item.groupId){
            delete item.groupId;
        }
        delete item.ownerIds;
        delete item.lastUpdate;
        delete item.positionId;
        delete item.detectedBy;
        item.beacon = true;
        return item;
    }

    if(role === MANAGER){
        return (id) 
            ? <UpdateTrailer 
                id={ id } 
                filterDataForServer={filterDataForServer} 
                role={role} 
            /> 
            : <CreateTrailer 
                filterDataForServer={filterDataForServer} 
            />;
    }
    return (id) 
        ? <UpdateTrailer 
            id={ id } 
            filterDataForServer={filterDataForServer} 
            role={role} 
        /> 
        : <Route element={<Navigate to="signage/trailers" />}/>;
};

export default TrailerPage;